import RoomList from './room-list';
import { request, config } from 'lib';
import utils from 'modules/home/util';
import { useArray } from 'react-hanger';
import { useEffect } from 'react';

const Top = (props) => {
  const { top_list } = props;
  const topStar = top_list[0];

  return (
    <section className="common-sec top-recommend-sec clearfix">
      {topStar && (
        <div className="top-rmd-star-player ">
          <div id="index-player"></div>
          <div id="r-audio-box">
            <img
              src={topStar.app_pic_url || topStar.pic}
              className="audio-bg"
            />
            <img
              src={
                topStar.pic || 'https://img.sumeme.com/3/3/1559108259459.png'
              }
              className="audio-avatar"
            />
          </div>
          <div className="player-top">
            <div className="player-star-info">
              <img src={topStar.pic || config.defaultImg} />
              <div>
                <p>{topStar.nick_name}</p>
                <span>观看人数：{topStar.count}</span>
              </div>
            </div>
            <div className="player-watermark">
              <i className="icon-player-watermark"></i>
              <div className="player-roomid">房间ID：{topStar.id}</div>
            </div>
          </div>
          <a
            href={`/${topStar.id}?clickfrom=J101`}
            target="_blank"
            className="player-enter-room-btn"
          >
            进入直播间
          </a>
          <div className="horn">
            <i className="icon-horn"></i>
            <i className="icon-horn-mute"></i>
          </div>
        </div>
      )}

      <div className="top-rmd-stars">
        <RoomList
          data={{
            list: top_list,
            max: 6,
            showLive: false,
            showCount: false,
            showCover: true,
            isRedirect: false,
            isLazy: true,
            saId: '001t02l01+000',
          }}
          clickfrom="J101"
        ></RoomList>
      </div>
    </section>
  );
};

export default Top;
